import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Input } from 'reactstrap';
import { Target, Info, CheckCircle, PlusCircle } from 'react-feather';
import { Link } from 'react-router-dom';
import { Done, All, Doing, CreateNewProject,pinagareAPIURL } from '../../../Constant';
import { Breadcrumbs, Image, P, H4, H5, H6, Btn, DRTScrumbs } from '../../../AbstractElements';
import ProjectContext from '../../../_helper/Project';
import CustomizerContext from '../../../_helper/Customizer';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from "react-toastify";
import EmailContext from '../../../_helper/Email';
import page_icon from '../../../assets/images/drts_home/my_drafts_ico.png';
import { eServiceData } from './eServiceData';
import AlleServices from './AlleServices'; 



const DRTSDrafts = () => { 
  const { layoutURL } = useContext(CustomizerContext);
  const [activeTab, setActiveTab] = useState('1');
  const { allData } = useContext(ProjectContext);
  const { setIsDataIn } = useContext(EmailContext);
  


  const style = {
    width: 40,
    height: 40,
  };
const style2 = { width: 60, fontSize: 14, padding: 4 };

   
const [taskData, setTaskData] = useState([]);
let newList = [...taskData];
const [pinagareItems, setPinagareItems] = useState([]);
const [pinagareTotalRows, setPinagareTotalRows] = useState(0);
const [pinagarePerPage, setPinagarePerPage] = useState(10);
const [isPrepopulatedDataIn, setIsPrepopulatedDataIn] = useState(false);
const [pinagareSupervisorTasks, setPinagareSupervisorTasks] = useState([]);


const productColumns = [

{
  name: 'Application Details',
  selector: (row) => row.Details,
  sortable: true,
  center: false,
  wrap: true,
  minWidth: '350px',
},
{
  name: 'Employee ID',
  selector: (row) => row.amount,
  sortable: true,
  center: true,
  minWidth: '100px',
  maxWidth: '150px',
},
{
  name: 'Status',
  selector: (row) => row.stock,
  sortable: true,
  center: true,
  minWidth: '170px',
  maxWidth: '230px',
},
{
  name: 'Application Date',
  selector: (row) => row.start_date,
  sortable: true,
  center: true,
  minWidth: '150px',
  maxWidth: '150px',
},
{
  name: 'Action',
  selector: (row) => row.action,
  sortable: true,
  center: true,
  minWidth: '100px',
  maxWidth: '130px',
},
];



useEffect(() => {



if(!isPrepopulatedDataIn){

  const body_t=JSON.stringify({
    
    omang:localStorage.getItem('username'),
    eng:'fetch_pinagare_supervisor_tasks',       
    
  });

  pinagareFetchRequest(pinagareAPIURL,body_t,'fetch_pinagare_supervisor_tasks');  

}

  
}, [isPrepopulatedDataIn]);


async function pinagareFetchRequest(url,body,eng) {
try {
  await fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: body,
  })
    .then((respose) => {
      if (respose.ok) {
       
        return respose.json()
      }
      throw new Error('error')
    })
    .then((data) => {

      
      if (data.status!=null&&data.status==true) {

     
        if(data.supervisorHasPendingTasks){

        setPinagareSupervisorTasks(data.tasks); //console.log(JSON.stringify(data.tasks));
          
        setIsPrepopulatedDataIn(true);

        //toast.success("Tasks fetch Successful..."); 

        let templateTaskData=null;
        let newListo = [];
        let thisSupervisorTasks=data.tasks;

//if(isPrepopulatedDataIn&&pinagareSupervisorTasks!=null&&pinagareSupervisorTasks.length>0){thisSupervisorTasks.length

let thisMaxi=pinagarePerPage > thisSupervisorTasks.length? thisSupervisorTasks.length:pinagarePerPage;

for(let i=0;i<thisMaxi;i++){
   
    templateTaskData =    {
     
      Details: (
        <div>
          <H6>{thisSupervisorTasks[i].names}</H6>
          <span>{thisSupervisorTasks[i].scheme}</span>
        </div>
      ),
      amount: thisSupervisorTasks[i].amount,
      stock: <div className='font-success'>{thisSupervisorTasks[i].current_status}</div>,
      start_date: thisSupervisorTasks[i].application_date,
      action: (
        <div>              
          <span>
            <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+thisSupervisorTasks[i].application_id}>                          
               <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
            </Link>
          </span>
        </div>
      ),
    }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setPinagareItems(newListo);
setPinagareTotalRows(thisSupervisorTasks.length);

//}

        }
        else{

          //toast.error("No pending tasks...");

        }

       
                      
      } else {

        if (data.status!=null&&data.status==false) {
          //toast.error(data.message);
        }
        else{
          //toast.error("No pending tasks...");
        }

                   
          setIsDataIn(false);           
          setIsPrepopulatedDataIn(false);
     

      }
    })
} catch (error) {
 
  //toast.error("Making Data Fetch/Submit Request failed...");
  
         
    setIsPrepopulatedDataIn(false);
 

}
}




const handlePageChange = (page) => {
  
  
  let templateTaskData=null;
        let newListo = [];        
        let thisMax=page*pinagarePerPage;
        let thisMin=thisMax-pinagarePerPage;

        

if(isPrepopulatedDataIn&&pinagareSupervisorTasks!=null&&pinagareSupervisorTasks.length>0){

  if(thisMax > pinagareSupervisorTasks.length){
    thisMax=pinagareSupervisorTasks.length;
    thisMin=pinagareSupervisorTasks.length-pinagarePerPage;
  }

  if(thisMax < pinagarePerPage)thisMin=0;

for(let i=thisMin;i<thisMax;i++){
   
    templateTaskData =    {
     
      Details: (
        <div>
          <H6>{pinagareSupervisorTasks[i].names}</H6>
          <span>{pinagareSupervisorTasks[i].scheme}</span>
        </div>
      ),
      amount: pinagareSupervisorTasks[i].amount,
      stock: <div className='font-success'>{pinagareSupervisorTasks[i].current_status}</div>,
      start_date: pinagareSupervisorTasks[i].application_date,
      action: (
        <div>              
          <span>
            <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+pinagareSupervisorTasks[i].application_id}>                          
               <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
            </Link>
          </span>
        </div>
      ),
    }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setPinagareItems(newListo);

}
}

const handlePerRowsChange = async (newPerPage, page) => { 
  setPinagarePerPage(newPerPage);
}

useEffect(() => {
 
  handlePageChange(1);

}, [pinagarePerPage]);



  return (
    <Fragment>
      <Breadcrumbs />
      <Container fluid={true}>

      <Row className="project-card" style={{width:"100%",textAlign:"center", padding:10, borderRadius: "0.7rem", margin:10}}>
          <Col md="12" className="project-list" style={{width:"100%",textAlign:"center", margin:0, padding:0, borderRadius: "0.7rem", backgroundColor:"#ffffff"}}>            
           
             <Row style={{textAlign:"center", padding:0, width:"100%", margin:0}}>
            
          <Col md='1' style={{textAlign:"center", width:"5%", backgroundColor:"#ffffff",padding:0, borderRadius: "0.7rem", margin:0}}>{" "}
          </Col>
          <Col md='10' style={{textAlign:"center", width:"90%", backgroundColor:"#ffffff", padding:0, borderRadius: "0.7rem", margin:0}}>			 
           
               <DRTScrumbs parent="Home" title="My Drafts" mainTitle="MY DRAFTS" />           
          </Col>

          <Col md='1' style={{textAlign:"center", width:"5%", backgroundColor:"#ffffff", padding:0, borderRadius: "0.7rem",margin:0}}>{" "} 
          </Col>

          </Row>    

          </Col>
        </Row>
  
		
		 <Row className="project-card">
          <Col md="12" className="project-list">
            <Card>
              <Row style={{width:"100%"}}>
                <Col md="3" style={{ width:"20%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
                
                 <Image attrImage={{ src: `${page_icon}`, 
                 alt: 'Welcome to DRTS Web Portal', width:180, 
                 border: '1px solid white', borderRadius:"1rem", textAlign: "center", margin:0, overflow: 'hidden' }} />
                           
                </Col>
				
				        <Col md="9" style={{width:"80%", backgroundColor:"#ffffff"}}>

                      
                  <Card className='schedule-card'>
                    <CardBody className='pt-0'>
                        <div style={{textAlign:"center", align:"center"}}><br /><br /><br />{"You have no drafts!"} </div>
                   </CardBody>
                  </Card>

                 

                </Col>
               
              </Row>
            </Card> 
          </Col>
                  
        </Row>
		
		
		
		
		
		
      </Container>
    </Fragment>
  );
};

export default DRTSDrafts;